import React, { useCallback } from 'react';
import {makeStyles, Container, Typography, IconButton, Checkbox, Hidden, Tabs, Tab, AppBar} from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import {MuiThemeProvider} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../API/customAxios";
import {FormattedMessage, useIntl} from 'react-intl';
import TabPanel, {a11yProps} from "../UIComponent/TabPanel";
import ApprovalHistory from "./ApprovalHistory";
import {getApproves} from "./api/ApprovalAPI";
import {setCashOutApprovalColumns, setCashOutApprovalOptions} from "./TableSetting";
import {tableStyle, getMuiTheme, pxToRem} from "../UIComponent/CommonStyle"
import {isBrowser} from "react-device-detect";
import Grid from "@material-ui/core/Grid";
import CompLeaveReqsApproval from '../CompLeaveReqsApproval';
import { useParams, useLocation } from "react-router-dom";
import { checkIsNewCompLeave, setLocalStorageSettings } from '../Function/globalFunction';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { getCashOutApproves } from '../CashOut/api/ApprovalAPI';
import { CashOutApprovalCollection } from '../Function/CashOutApproval';
import moment from 'moment';
import { ValidatorForm } from 'react-material-ui-form-validator';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from "react-modern-calendar-datepicker";
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import ConfirmBox from './component/ConfirmBox';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

let isApprove = '';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 13,
    },
}));

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
    datePickerContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    datePickerInput: {
        textAlign: 'left',
        padding: '1rem 1rem',
        fontSize: pxToRem(14),
        border: '1px solid #B8B8B8',
        borderRadius: 5,
        outline: 'none',
        height: 'fit-content',
        minWidth: '100%',
        [breakpoints.up('md')]: {
            fontSize: pxToRem(16),
            height: pxToRem(61),
        },
    },
    datePickerCalendar: {
        border: '1px solid #B8B8B8',
        fontSize: 8,
        [breakpoints.up('md')]: {
            fontSize: 10,
        },
    },
    titleHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px',
        position: 'relative',
        zIndex: 1000,
    },
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		padding: '0 4px',
		fontSize: '0.9rem',
		minWidth: '16px',
		height: '16px',
	},
}));

const breakpoints = createBreakpoints({});

export default function CashOut({routing, routingId, source}) {
    const location = useLocation();
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const today = moment();
    const form = React.useRef();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [selectItem, setSelectItem] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    // const [showSelectBox, setShowSelectBox] = React.useState('multiple');
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [selectedRowsData, setSelectedRowsData] = React.useState({
        selectedRows: '',
        displayData: '',
    });
    const [tabValue, setTabValue] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [open, setOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [numberOfPendingLeaves, setNumberOfPendingLeaves] = React.useState();
    const [numberOfPendingOTs, setNumberOfPendingOTs] = React.useState();
    const [approvesLoaded, setApprovesLoaded] = React.useState(false);
    const [compLeavesLoaded, setCompLeavesLoaded] = React.useState(false);
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;
    const isHRAdminRole = JSON.parse(localStorage.getItem('isHrAdminRole'));
    const [cutOffDate, setCutOffDate] = React.useState({
        day: Number(today.format('DD')),
        month: Number(today.format('MM')),
        year: Number(today.format('YYYY')),
    });
    const [departmentFilter, setDepartmentFilter] = React.useState([window.global.fmDepartment]);
    const [staffStatusFilter, setStaffStatusFilter] = React.useState(['Active']);
    const [isTooltipOpen, setIsTooltipOpen] = React.useState(false);

    const tab1Label = intl.formatMessage({ id: 'navigation.approval' });
    const tab2Label = intl.formatMessage({ id: 'navigation.history' });

    React.useEffect(() => {
        let isMounted = true;

        async function getPermission() {
            let isHrAdminRole = JSON.parse(localStorage.getItem('isHrAdminRole'));

            if (isHrAdminRole === null) {
                const permissionResponse = await customAxios.get('/get_permission');
                if (isMounted) {
                    isHrAdminRole = permissionResponse.data.hr_admin === true;
                    localStorage.setItem('isHrAdminRole', isHrAdminRole);
                }
            }
        }
        getPermission();

        return () => {
            isMounted = false;
        };
    }, []);

    React.useEffect(() => {
        let isMounted = true;

        if (tabValue == 0) {
            async function fetchCashOutApproves() {
                if (!isHRAdminRole) {
                    history.push('/home');
                    return;
                }

                try {
                    setShowCompetent(false);
                    setSelectItem([]);
                    setSelectedRows([]);

                    const response = await getCashOutApproves(cutOffDate);
                    if (isMounted && response.status === 200) {
                        setData(CashOutApprovalCollection(response.data, intl));
                        setShowCompetent(true);
                        setApprovesLoaded(true);
                    }
                } catch (error) {
                    if (isMounted) {
                        console.error("Failed to fetch leave approval data:", error);
                        setShowCompetent(false);
                    }
                }
            }
            fetchCashOutApproves();
        }

        return () => {
            isMounted = false;
        };
    }, [cutOffDate, tabValue]);

    React.useEffect(() => {
        if (routing !== '') {
            setShowId(routingId)
            setOpen(routing);
        }
    }, [routing, routingId]);

    React.useEffect(() => {
        // setRowsPerPage(data.length);
        const params = new URLSearchParams(location.search);

        const tabIndex = params.get('tabIndex') ?? 0;
        setTabValue(Number(tabIndex));
    }, [location, data]);

    const handleConfirmOpen = (selectIndex, selectData, action) => {
        isApprove = action;
        setConfirmOpen(true);
        setSelectedRowsData({
            selectedRows: selectIndex,
            displayData: selectData
        })
    };
    const handleConfirmClose = () => {
        setConfirmOpen(false);
        // setSelectItem(selectedRows);
    };

    const handleChange = (event) => {
        setChecked(event.target.checked);
        if (event.target.checked === true) {
            setSelectItem([...Array(data.length).keys()])
        } else {
            setSelectItem([])
        }
    }

    let customToolbar = () => {
        return (
            <Hidden mdUp>
                {/* { showSelectBox ? */}
                <IconButton style={{order: -1, height: pxToRem(45)}}>
                    <Checkbox
                        style={{color: '#FFF'}}
                        checked={checked}
                        onChange={handleChange}
                        inputProps={{'aria-label': 'primary checkbox'}}
                    />
                </IconButton>
                {/* : null */}
            </Hidden>
        );
    }
    let customToolbarSelect = (selectedRows, displayData, setSelectedRows) => (
        <React.Fragment>
            <div className={classes.customToolbarSelect}>
                <IconButton onClick={() => handleConfirmOpen(selectedRows.data, displayData, 'approve')}>
                    <CheckCircleIcon className={classes.deleteIcon} style={{color: '#FFF'}}/>
                    <Typography className={classes.customToolbarSelectText}
                                style={{color: '#FFF'}}>{intl.formatMessage({id: 'leave_approval.approval'})}</Typography>
                </IconButton>
                <Hidden mdUp>
                    <IconButton>
                        <Checkbox
                            style={{color: '#FFF'}}
                            checked={checked}
                            onChange={handleChange}
                            inputProps={{'aria-label': 'primary checkbox'}}
                        />
                    </IconButton>
                </Hidden>
            </div>
        </React.Fragment>
    );

    const handleFilterChange = (newFilterList) => {
        if (Array.isArray(newFilterList)) {
            setDepartmentFilter(newFilterList);
            setStaffStatusFilter(newFilterList);
        }
    };

    let columns = setCashOutApprovalColumns(
        departmentFilter,
        staffStatusFilter,
        handleFilterChange,
        isTooltipOpen
    );

    const handleRowsPerPageChange = useCallback((newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
    }, [setRowsPerPage]);

    let options = {
        ...setCashOutApprovalOptions(
            selectItem,
            customToolbar,
            customToolbarSelect,
            rowsPerPage,
            handleRowsPerPageChange,
            (newDepartmentFilter) => setDepartmentFilter(newDepartmentFilter),
            (newStaffStatusFilter) => setStaffStatusFilter(newStaffStatusFilter)
        ),
        onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
            setSelectedRows(rowsSelected);
            setSelectItem(rowsSelected);
        }
    };

    if (isBrowser === false) {
        columns = columns.filter(item => item.name !== 'approve')
    }

    const handleTabChange = (event, newValue) => {
        if (newValue == 0) {
            history.push('/cash_out');
        }
        setTabValue(newValue);
    };

    const handleTooltipOpen = () => {
        setIsTooltipOpen(true);
    };

    const handleTooltipClose = () => {
        setIsTooltipOpen(false);
    };

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <AppBar position='static' color='default'>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor='primary'
                    textColor='primary'
                    variant='scrollable'
                    scrollButtons='auto'
                >
                    <Tab
                        label={
                            <span style={{ padding: '0 10px' }}>
                                {tab1Label}
                            </span>
                        }
                        {...a11yProps(0)}
                    />
                    <Tab
                        label={
                            <span style={{ padding: '0 10px' }}>
                                {tab2Label}
                            </span>
                        }
                        {...a11yProps(1)}
                    />
                </Tabs>
            </AppBar>
            <TabPanel value={tabValue} index={0} disableGutters={true}>
                <Container maxWidth={false} className={classes.container}>
                    {showCompetent ? (
                        <>
                            <Grid item xs={12}>
                                <div className={classes.titleHeader}>
                                    <Typography
                                        component='h1'
                                        variant='h5'
                                        align='left'
                                        style={{ fontWeight: 600 }}
                                    >
                                        <>
                                            {intl.formatMessage({
                                                id: 'navigation.cash_out_approval',
                                            })}
                                        </>
                                    </Typography>
                                    <div
                                        className={classes.datePickerContainer}
                                    >
                                        <LightTooltip
                                            title={intl.formatMessage({
                                                id: 'cash_out.cut_off_date_tooltip',
                                            })}
                                            placement='top'
                                            open={isTooltipOpen}
                                            onOpen={handleTooltipOpen}
                                            onClose={handleTooltipClose}
                                            slotProps={{
                                                popper: {
                                                    sx: {
                                                        [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                                                            {
                                                                marginBottom:
                                                                    '5px',
                                                            },
                                                    },
                                                },
                                            }}
                                        >
                                            <InfoOutlinedIcon />
                                        </LightTooltip>
                                        <span
                                            style={{
                                                margin: '0 10px 0 5px',
                                                fontWeight: 600,
                                                fontSize: pxToRem(16),
                                            }}
                                        >
                                            {intl.formatMessage({
                                                id: 'cash_out.cut_off_date',
                                            })}
                                        </span>
                                        <DatePicker
                                            value={cutOffDate}
                                            onChange={setCutOffDate}
                                            shouldHighlightWeekends
                                            inputClassName={
                                                classes.datePickerInput
                                            }
                                            calendarClassName={
                                                classes.datePickerCalendar
                                            }
                                            calendarPopperPosition='bottom'
                                        />
                                    </div>
                                </div>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <MUIDataTable
                                            title={intl.formatMessage({
                                                id: 'table.employee_list',
                                            })}
                                            data={data}
                                            columns={columns}
                                            options={options}
                                        />
                                    </MuiThemeProvider>
                                </Grid>
                            </Grid>
                        </>
                    ) : (
                        <div className={classes.circularProgress}>
                            <CircularProgress />
                        </div>
                    )}
                </Container>
            </TabPanel>
            <TabPanel value={tabValue} index={1} disableGutters={true}>
                <ApprovalHistory />
            </TabPanel>
            {confirmOpen && (
                <ConfirmBox
                    approveMode={window.global.multipleApprove}
                    leaveMode={window.global.CashOut}
                    handleClose={handleConfirmClose}
                    open={confirmOpen}
                    // selectedRows={selectedRowsData.selectedRows}
                    selectedRows={selectedRows}
                    displayData={selectedRowsData.displayData}
                    isApprove={isApprove}
                    tabIndex={tabValue}
                    cutOffDate={cutOffDate}
                />
            )}
        </main>
    );
}